import classNames from "classnames/bind"
import PropTypes from "prop-types"
import React from "react"

import DiscountBadge from "../../International/DiscountBadge/DiscountBadge"
import Discounted from "./Discounted"
import PricingHeader from "./PricingHeader"
import Regular from "./Regular"

import gridStyles from "../../../components/Plans.module.css"

const cx = classNames.bind(gridStyles)

const headerClass = cx("row", "header", "planColumnHeadingCell", "fullheight")

const Pricing = props => {
  const { plans, lang } = props

  return plans.map(plan => (
    <div key={`PRICING_${plan.name}`} className={headerClass}>
      {plan.isDiscountApplied && (
        <div className={gridStyles.discountWrapper}>
          <DiscountBadge name={plan.discount.promotion_name} />
        </div>
      )}
      <div className="flex-container f-a-center f-d-col f-j-between fullheight p-b-15">
        <PricingHeader
          displayName={plan.displayName}
          name={plan.name}
          type={plan.type}
        />
        {plan.isDiscountApplied ? (
          <Discounted plan={plan} lang={lang} />
        ) : (
          <Regular plan={plan} lang={lang} />
        )}
      </div>
    </div>
  ))
}

Pricing.propTypes = {
  plans: PropTypes.array,
  lang: PropTypes.string,
}
Pricing.defaultProps = { plans: [], lang: "en" }

export default Pricing
